import classNames from 'classnames';
import React, { ReactElement } from 'react';

import styles from './NumberedPagination.module.css';
import { INumberedPaginationPagesProps } from './NumberedPagination.types';
import { NumberedPaginationButton } from './NumberedPaginationButton';

export function NumberedPaginationPages (props: INumberedPaginationPagesProps): ReactElement {
    const {
        pages,
        currentPage,
        handleChange,
        separator,
        className = '',
        'data-testid': dataTestId = '',
    }: INumberedPaginationPagesProps = props;

    function createClickHandler (page: string): (event: React.MouseEvent<HTMLButtonElement>) => void {
        return (event): void => {
            event.preventDefault();

            if (page === separator) {
                return;
            }

            handleChange(parseInt(page));
        };
    }

    const customClassName: string = classNames({
        [styles.pages]: true,
        [className]: !!className,
    });

    return (
        <div className={customClassName} data-testid={dataTestId}>
            {
                pages.map((page: string, index: number): ReactElement => {
                    const pageClassName: string = classNames({
                        [styles.animateUnderline]: page !== separator,
                        'cursor-default': page === separator,
                        [styles.animateUnderlineActive]: page === currentPage.toString(),
                    });

                    return (
                        <div className="px-3/2" key={`${page}_${index}`}>
                            <NumberedPaginationButton
                                onClick={createClickHandler(page)}
                                prominent={page === currentPage.toString()}
                            >
                                <span className={pageClassName}>
                                    {page}
                                </span>
                            </NumberedPaginationButton>
                        </div>
                    );
                })
            }
        </div>
    );
}
